export default function config() {
  // Table Handlers
  const tableColumns = [
    { key: 'index', label: '#' },
    { key: 'subject', label: 'Subject', sortable: true },
    { key: 'exam_date', label: 'Exam date', sortable: true },
    { key: 'comment', label: 'Comment', sortable: true },
    { key: 'period', label: 'Period', sortable: true },
    { key: 'actions', label: 'Actions' },
  ]

  return {
    tableColumns,
  }
}
